module.exports = __webpack_public_path__ + "static/media/logo-s4s-off.1bcb74c9.svg";